import React from "react";
import TreeView from "./TreeView";

const TreeContainer = ({
  tree1,
  tree2,
  onChange,
  handleSelectItem,
  onDoubleClick,
  template,
}) => {
  return (
    <div style={{ display: "flex", gap: 20 }}>
      <TreeView
        title="Menu master"
        data={tree1}
        onDoubleClick={onDoubleClick}
        handleSelectItem={handleSelectItem}
        onChange={(updated) => onChange("tree1", updated)}
        template={template}
      />

      {tree2?.length > 0 && (
        <TreeView
          title="Tree B"
          handleSelectItem={handleSelectItem}
          data={tree2}
          onDoubleClick={onDoubleClick}
          onChange={(updated) => onChange("tree2", updated)}
          template={template}
        />
      )}
    </div>
  );
};

export default TreeContainer;
